export default "__VITE_ASSET__BTktAp1c__"